

export default function( space, url_modifier )
{
    //currently loading bundles:
    const queue = []
    
    //sounds only which was already requested to load but postponed until player will turn sounds on:
    const p_sounds = []

    const $loading = space.s( 'loading' )

    //load specified bundle:
    space.s( 'load' )
        .do( bundle => {
            if ( Array.isArray( bundle ) ) {
                for ( const b of bundle ) queue.push( b )
            }
            else {
                queue.push( bundle )
            }
        } )
        .to( space.s( 'continue' ) )
    
    const $progress = space.s( 'progress' )
    const report_progress = () => {
        let progress = 0

        if ( $loading.value.sounds ) progress += $loading.value.sounds_fraction * $loading.value.sounds.length / $loading.value.whole
        if ( $loading.value.graphics ) progress += $loading.value.graphics_fraction * $loading.value.graphics / $loading.value.whole

        $progress.next( progress )
    }

    const $complete = space.s( 'complete' )
    $complete.to( space.s( 'continue' ) )
    const try_handle_complete = () => {
        if ( $loading.value.graphics && ! $loading.value.graphics_loaded ) return
        if ( $loading.value.sounds && ! $loading.value.sounds_loaded ) return

        if ( $loading.value.bundle ) {
            queue.shift()

            delete $loading.value.bundle.loading
            $loading.value.bundle.loaded = true
        }

        const t = $loading.value
        $loading.next()


        $complete.next( {
            bundle : t.bundle,
            sounds : t.sounds ? true : false
        } )
    }
    
    space.s( 'continue' )
        .with(
            space.s( 'postpone_sounds' ),
            $loading,
            ( _, p, loading ) => ({ p, loading })
        )
        .on( ({ p, loading }) => {
            if ( loading ) return

            const bundle = queue[ 0 ]

            if ( bundle && ( bundle.loading || bundle.loaded ) ) return
            if ( bundle ) bundle.loading = true

            //moving sounds to postponation:
            if ( bundle && bundle.sounds ) {
                for ( const s of bundle.sounds ) p_sounds.push( s )
            }
            
            let whole = (bundle && bundle.graphics) ? (bundle.graphics.length || 0) : 0;

            let l_sounds = undefined

            if ( ! p && p_sounds.length > 0 ) {
                whole += p_sounds.length

                l_sounds = []
                for ( let i = p_sounds.length; i > 0; -- i ) l_sounds.push( p_sounds.shift() )

                sounds.load(
                    l_sounds,
                    () => {
                        $loading.value.sounds_loaded = true
                        try_handle_complete()
                    },
                    progress => {
                        $loading.value.sounds_fraction = progress
                        report_progress()
                    },
                    url_modifier
                )
            }
            
            //if nothing to load:
            if ( whole <= 0 ) {
                //if just empty bundle:
                if ( bundle ) {
                    queue.shift()
                    $complete.next({
                        bundle,
                        sounds : false,
                    })
                }
                return
            }

            $loading.next( {
                whole,

                graphics : ( bundle && bundle.graphics ) ? bundle.graphics.length : 0,
                sounds : l_sounds,

                graphics_fraction : 0,
                sounds_fraction : 0,

                bundle,
            } )

            if ( bundle && bundle.graphics && bundle.graphics.length > 0 ) {
                PIXI.loader.progress = 0
                PIXI.loader.add( bundle.graphics ).load( () => {
                    $loading.value.graphics_loaded = true
                    $loading.value.graphics_fraction = 1.0

                    try_handle_complete()
                } )
            }
        } )

    space.s( 'postpone_sounds' ).to( space.s( 'continue' ) )
    
    PIXI.loader.on( 'progress', ( loader, resource ) => {
        $loading.value.graphics_fraction = loader.progress / 100.0
        report_progress()
    } )

    const $error = space.s( 'error' )
    PIXI.loader.on( 'error', msg => $error.next( msg ) )
}





// WEBPACK FOOTER //
// ./src/library/load.es6